import MTooltip from './MTooltip.vue';

MTooltip.install = (app) => {
  app.component('MTooltip', MTooltip);
};

export { MTooltip };
